module.exports = __webpack_public_path__ + "static/img/paiduitongzhi2.520bece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/paiduitongzhi2.png
// module id = ilRG
// module chunks = 24